<div class="flex flex-col gap-4 pb-8 h-full">
  @if (showImageAlert()) {
    <stch-alert
      class="mx-8"
      [customConfig]="{ title: '' }"
      type="warning"
      message="External images are blocked to protect your privacy"
      actionLabel="Load images"
      (actionClick)="onLoadImages()"
    />
  }

  <!-- mt-9: the text starts about as far under the Knowledge box as a note's does (Johanna, 2026-10-22). -->
  <div
    #bodyScroll
    class="form-scroll flex-1 relative px-8 mt-9 h-full overflow-y-auto"
    [stchKnowledgeMarkerSelectionTooltip]="message()"
  >
    <!-- The policy is static on purpose: sandbox/allow/referrerpolicy are never bound, and the document is navigated to in code.
         Never scripts. Popups only so the browser opens each link (target=_blank, noopener noreferrer) as a normal tab;
         downloads only from a link the reader clicks. -->
    <iframe
      #frame
      class="block w-full border-0"
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
      referrerpolicy="no-referrer"
      allow=""
      title="Message body"
      data-stch-email-frame
      [class.pointer-events-none]="frameInert()"
    ></iframe>
  </div>
</div>
